<template>
    <b-overlay :show="show" rounded="sm" variant="dark" opacity="1">
        <div v-if="client_loading_status == true" class="text-center">
            <b-spinner small type="grow"></b-spinner>
            Loading...
        </div>
        <div v-else-if="clients.length > 0">
            <webix-ui :config="ui" v-model="client_data"></webix-ui>
            <div id="clientsTablePaging"></div>
        </div>
        <div v-else class="ml-2">
            Something went wrong
        </div>
    </b-overlay>
</template>

<script>
import { adminComputed, clientsComputed, clientsMethods, collectionsListMethods } from "../../../state/helpers";
//eslint-disable-next-line
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";

export default {
    data: () => ({
        show: false,
    }),
    computed: {
        ...adminComputed,
        ...clientsComputed,
        client_data() {
            return cloneDeep(this.clients);
        },
        ui() {
            //eslint-disable-next-line
            let el = this;

            let ui = {
                id: "clientsTable",
                view: "datatable",
                css: "datatableUsers webix_header_border webix_data_border datatableHover",
                autoheight: true,
                // hover: "datatableHover",
                // select: "cell",
                // hover: "clientsTableHoverRow",
                minHeight: 50,
                minColumnWidth: 120,
                rowHeight: 30,
                scrollY: false,
                scrollX: true,
                resizeColumn: true,
                editable: true,
                columns: [
                    {
                        id: "assigned_collection",
                        // header: [{ content: "masterCheckbox" }],
                        header: { text: "Collect", css: { "text-align": "center" } },
                        template: function(obj) {
                            if (obj.assigned_collection == false) {
                                return `<div class="on_collect"><i v-b-tooltip.hover title="Add to Collection List" class="bx bx-toggle-left bx-md non-active_switch"></i> </div>`;
                            }
                            if (obj.assigned_collection == true) {
                                return `<div v-b-tooltip.hover title="Remove from Collection List" class="on_collect"> <i class="bx bxs-toggle-right bx-md active_switch"></i> </div>`;
                            }
                        },
                        maxWidth: 85,
                        css: { "text-align": "center" },
                        sort: "int",
                    },
                    {
                        id: "name",
                        header: ["Company Name", { content: "textFilter" }],
                        // fillspace: 1,
                        width: 300,
                        sort: "string",
                    },
                    {
                        id: "contact",
                        header: ["Contact Person", { content: "textFilter" }],
                        // fillspace: 1,
                        width: 200,
                        sort: "string",
                    },
                    {
                        id: "email",
                        header: ["Email", { content: "textFilter" }],
                        width: 300,
                        // fillspace: 1,
                        sort: "string",
                    },
                ],
                ready: function() {
                    //eslint-disable-next-line
                    var state = webix.storage.local.get("clientsTable");
                    //eslint-disable-next-line
                    let table = window.webix.$$("clientsTable");
                    //eslint-disable-next-line
                    setTimeout(() => {
                        // TODO: uncomment to retrieve table state
                        // table.setState(state);
                        //set to 100 otherwise the filter doesnt apply
                    }, 100);
                },
                //eslint-disable-next-line
                onClick: {
                    // name click method needs to match a class on the image -- eg 'table_toggle_button'
                    on_collect: function(event, id) {
                        let item = this.getItem(id);

                        //eslint-disable-next-line
                        let el = this.$scope.$parent.$parent;

                        el.handleSwal(item);
                    },
                },
            };

            //pager
            if (this.clients.length > 15) {
                ui.pager = {
                    template: "{common.prev()} {common.pages()} {common.next()}",
                    container: "clientsTablePaging",
                    css: { width: "100% !important" },
                    size: 15,
                    group: 5,
                };
            }

            return ui;
        },
    },
    methods: {
        ...clientsMethods,
        ...collectionsListMethods,
        resetTableState() {
            let table = window.webix.$$("clientsTable");
            //manually remove filter
            table.filter("", "");
            table.sort("", "");
            localStorage.removeItem("clientsTable");

            setTimeout(() => {
                table.setState({
                    ids: ["id", "assigned_collection", "name", "contact", "email", "reg_no", "vat_no"],
                    size: [120, 120, -1, -1, -1, -1, -1],
                    select: [],
                    scroll: { x: 0, y: 0 },
                    order: ["id", "assigned_collection", "name", "contact", "email", "reg_no", "vat_no"],
                    sort: { id: "assigned_collection", dir: "desc" },
                    filter: { name: "", contact: "", email: "", reg_no: "", vat_no: "" },
                    hidden: [],
                });
            }, 30);

            // table.sort("", "");
            // table.filterByAll();
        },
        loadTableStateFromLocalStorage() {
            var state = window.webix.storage.local.get("clientsTable");

            let table = window.webix.$$("clientsTable");

            //eslint-disable-next-line
            setTimeout(() => {
                table.setState(state);
            }, 80);
        },
        saveTableStateToLocalStorage() {
            let table = window.webix.$$("clientsTable");

            let table_state = JSON.stringify(table.getState());

            localStorage.setItem("clientsTable", table_state);
        },
        handleSwal(item) {
            let table = window.webix.$$("clientsTable");

            if (item.assigned_collection == false) {
                Swal.fire({
                    title: `Add the following client to the collection list:`,
                    text: `${item.name}`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Confirm",
                }).then((result) => {
                    if (result.value) {
                        item.on_collection = 1;

                        this.addClientToCollectionList({ collection_clients: [item.id], single_client: true }).then(() => {
                            Swal.fire(`${item.name} was added to the collection list`, "", "success");
                            table.updateItem(item.id, item);
                            //refreshes the table on the screen
                            this.setClients().then(() => {
                                this.loadTableStateFromLocalStorage();
                            });
                        });
                    } else {
                        //else just set it back to the state it was
                        item.on_collection = 0;
                        //row id and the obejct to update with
                        table.updateItem(item.id, item);
                        this.loadTableStateFromLocalStorage();
                    }
                });
            }

            if (item.assigned_collection == true) {
                Swal.fire({
                    title: `Remove the following client from the collection list:`,
                    text: `${item.name}`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Confirm",
                }).then((result) => {
                    if (result.value) {
                        item.on_collection = 0;

                        this.deleteCollectionListRecord({ client_id: item.id }).then(() => {
                            Swal.fire(`${item.name} was removed from the collection list`, "", "success");

                            table.updateItem(item.id, item);
                            //refreshes the table on the screen
                            this.setClients().then(() => {
                                this.loadTableStateFromLocalStorage();
                            });
                        });
                    } else {
                        item.on_collection = 1;
                        table.updateItem(item.id, item);
                        this.loadTableStateFromLocalStorage();
                    }
                });
            }
        },
    },
    mounted() {
        if (this.clients.length == 0) {
            this.setClients().then(() => {});
        }

        if (localStorage.getItem("clientsTable")) {
            //eslint-disable-next-line
            // console.log("it exists §§§§§", localStorage.getItem("clientsTable"));
        } else {
            //eslint-disable-next-line
            // console.log("it does not exist", localStorage.getItem("clientsTable")); // will return null
        }
    },
    beforeDestroy() {
        this.saveTableStateToLocalStorage();
        // this.table_loaded = false;
    },
};
</script>

<style lang="scss">
.active_switch {
    // color: darken(#28a745, 10%);
    cursor: pointer;
}
.non-active_switch {
    cursor: pointer;
}
.clientsTableHoverRow {
    background: #f0dcb6;
    cursor: text;
}

.webix_view {
    border: 1px solid #ccc;
}
.webix_header {
    background-color: #f7f7f7;
    border-bottom: 1px solid #ccc;
}
/* Toggle switch container */
.toggle-container {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

/* Toggle switch checkbox */
.toggle-container input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* Toggle switch slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked + .slider {
    background-color: #2196f3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
    transform: translateX(26px);
}
</style>
